export default "__VITE_ASSET__dmi_bZOu__";